/** Modules that are always accessible (mirrors backend is_core=True in seed.py). */
export const CORE_MODULES: readonly string[] = [
  'dashboard',
  'settings',
  'audit',
  'notifications',
  'billing',
] as const;
